// src/App.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar     from './components/Navbar';
import CartDrawer from './components/funnel/CartDrawer';
import FloatingCartFab from './components/funnel/FloatingCartFab';
import FooterSection from './sections/FooterSection';
import { useFunnelCart } from './context/FunnelCartProvider';
import AppRoutes  from './routes/AppRoutes';

export default function App() {
  const { pathname } = useLocation();
  const { totalQuantity, toggleDrawer, closeDrawer } = useFunnelCart();

  const isPortalSide = pathname.startsWith('/dashboard');
  const isJoinInviteRoute = pathname.startsWith('/join');
  const showNavbar = !isPortalSide && !isJoinInviteRoute;
  const isCapitalPartnerNetworkRoute = pathname.startsWith('/capital-partner-network');
  const isPublicMarketingRoute =
    pathname === '/' ||
    pathname === '/services' ||
    pathname.startsWith('/services/') ||
    pathname === '/pricing' ||
    pathname.startsWith('/insights-v2') ||
    pathname.startsWith('/blog') ||
    pathname.startsWith('/blogs') ||
    pathname.startsWith('/publications') ||
    pathname.startsWith('/works') ||
    pathname.startsWith('/case-study') ||
    pathname.startsWith('/case-studies') ||
    isCapitalPartnerNetworkRoute;
  const showMarketingFooter =
    pathname === '/' ||
    pathname === '/services' ||
    pathname.startsWith('/services/') ||
    pathname === '/pricing' ||
    pathname === '/careers' ||
    pathname.startsWith('/careers/') ||
    pathname === '/checkout' ||
    pathname.startsWith('/checkout/') ||
    pathname.startsWith('/insights-v2') ||
    pathname.startsWith('/blog') ||
    pathname.startsWith('/blogs') ||
    pathname.startsWith('/publications') ||
    pathname.startsWith('/works') ||
    pathname.startsWith('/case-study') ||
    pathname.startsWith('/case-studies') ||
    isCapitalPartnerNetworkRoute;
  const showFloatingCart = !isPortalSide && isPublicMarketingRoute && totalQuantity > 0;

  useEffect(() => {
    if (!showFloatingCart) {
      closeDrawer();
    }
  }, [closeDrawer, showFloatingCart]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      {showNavbar && <Navbar />}
      <AppRoutes />
      {!isPortalSide && showMarketingFooter ? <FooterSection /> : null}
      {showFloatingCart ? (
        <FloatingCartFab itemCount={totalQuantity} onOpen={toggleDrawer} />
      ) : null}
      {showFloatingCart ? <CartDrawer /> : null}
    </>
  );
}
